// 不要手动修改该文件，运行命令 npm run slide-menu
import IconHome from '@/components/icons/icon-home';
import IconActive from '@/components/icons/icon-active';
import IconDaily from '@/components/icons/icon-daily';
import IconChannel from '@/components/icons/icon-channel';
import IconPlantform from '@/components/icons/icon-plantform';
import IconMaterialManage from '@/components/icons/icon-material-manage';
import IconDataPanel from '@/components/icons/icon-data-panel';
import IconTrend from '@/components/icons/icon-trend';
import IconSystem from '@/components/icons/icon-system';
import IconTodo from '@/components/icons/icon-todo';
import IconProductManager from '@/components/icons/icon-product-manager';
import IconTree from '@/components/icons/icon-tree';
import IconPh from '@/components/icons/icon-ph';
import IconPlatformMarketing from '@/components/icons/icon-platformMarketing';
import IconFunctionMatrix from '@/components/icons/icon-function-matrix';
import PageTitle from '@/pages/all-about-me/activity-message-center/components/page-title';
export default [
  {
    menuId: 25,
    path: '/',
    title: '工作台',
    Icon: IconHome,
    getlog() {
      return 'yx_center_1629184833805|37';
    },
  },
  {
    menuId: 57,
    path: '/all-about-me',
    title: '待办事项',
    Icon: IconTodo,
    getlog() {
      return 'yx_center_1629184833805|38';
    },
    menus: [
      {
        menuId: 109,
        path: '/activity-message-center',
        title: <PageTitle />,
      },
      {
        menuId: 75,
        path: '/signed-activity',
        title: '活动报名',
        getLink({ parentPath }) {
          return parentPath + '/signed-activity/reportable-activities';
        },
      },
      {
        menuId: 58,
        path: '/audit-material',
        title: '待审核管理',
      },
      {
        menuId: 59,
        path: '/signed-material',
        title: '已报名素材',
        getlog() {
          return 'yx_center_1629184833805|49';
        },
      },
    ],
  },
  {
    menuId: 91,
    path: '/product-manager',
    title: '货主阵地',
    Icon: IconProductManager,
    menus: [
      {
        menuId: 92,
        path: '',
        title: '商品监控',
      },
      {
        menuId: 93,
        path: '/big-boss-panel',
        title: '场域监控',
      },
    ],
  },
  {
    menuId: 11,
    path: '/activity-manage/list',
    title: '主题活动',
    Icon: IconActive,
    businessId: 10003,
    getlog() {
      return 'yx_center_1629184833805|39';
    },
  },
  {
    path: '/activity-manage/myCreate',
    title: '日常活动',
    businessId: 10004,
    menuId: 53,
    Icon: IconDaily,
    getlog() {
      return 'yx_center_1629184833805|40';
    },
    menus: [
      {
        title: '会场活动',
        path: '/room',
        menuId: 54,
        getlog() {
          return 'yx_center_1629184833805|50';
        },
      },
      {
        title: '综合促销',
        path: '/zongcuActivity',
        menuId: 55,
        getlog() {
          return 'yx_center_1629184833805|51';
        },
      },
      // {
      //   path: '/ph',
      //   title: '盘货活动',
      //   menuId: 56,
      //   getLink({ path }) {
      //     return `${path}/phlist/manage`;
      //   },
      // },
    ],
  },
  // {
  //   path: '/marketing-field',
  //   title: '平台营销阵地',
  //   Icon: IconChannel,
  // },
  {
    menuId: 65,
    path: '/platform-marketing',
    title: '平台营销阵地',
    Icon: IconPlatformMarketing,
  },
  {
    menuId: 35,
    path: '/channel-service',
    title: '行业频道',
    Icon: IconChannel,
    getlog() {
      return 'yx_center_1629184833805|41';
    },
  },
  // {
  //   menuId: 3,
  //   title: '平台资源',
  //   path: '/material-manage',
  //   Icon: IconPlantform,
  //   getlog() {
  //     return 'yx_center_1629184833805|42';
  //   },
  //   menus: [
  //     {
  //       menuId: 37,
  //       title: '活动数据',
  //       path: '/activity-data/data/home',
  //       getlog() {
  //         return 'yx_center_1629184833805|52';
  //       },
  //     },
  //     {
  //       menuId: 24,
  //       title: '资源位列表',
  //       path: '/resource-list',
  //       getlog() {
  //         return 'yx_center_1629184833805|53';
  //       },
  //     },
  //     {
  //       menuId: 12,
  //       title: '申请管理',
  //       path: '/resource-manage',
  //       getlog() {
  //         return 'yx_center_1629184833805|54';
  //       },
  //     },
  //     {
  //       menuId: 36,
  //       title: '申请列表',
  //       path: '/resource-apply-list',
  //       getlog() {
  //         return 'yx_center_1629184833805|55';
  //       },
  //     },
  //     {
  //       menuId: 2,
  //       title: '资源广场',
  //       path: '/resource-square',
  //       getlog() {
  //         return 'yx_center_1629184833805|56';
  //       },
  //     },
  //   ],
  // },
  // {
  //   menuId: 39,
  //   title: '素材管理',
  //   Icon: IconMaterialManage,
  //   path: '/res-manage',
  //   getlog() {
  //     return 'yx_center_1629184833805|43';
  //   },
  //   menus: [
  //     {
  //       menuId: 40,
  //       title: '商品组',
  //       path: '/material/goods',
  //       getlog() {
  //         return 'yx_center_1629184833805|57';
  //       },
  //       getLink({ path }) {
  //         return `${path}#/product`;
  //       },
  //     },
  //     {
  //       menuId: 41,
  //       title: '广告组',
  //       path: '/material/adv',
  //       getlog() {
  //         return 'yx_center_1629184833805|58';
  //       },
  //       getLink({ path }) {
  //         return `${path}#/advert`;
  //       },
  //     },
  //     {
  //       menuId: 42,
  //       title: '潘多拉',
  //       path: '/pandora',
  //       getlog() {
  //         return 'yx_center_1629184833805|59';
  //       },
  //     },
  //     {
  //       menuId: 43,
  //       title: '自动化素材',
  //       path: '/auto',
  //       getlog() {
  //         return 'yx_center_1629184833805|60';
  //       },
  //     },
  //   ],
  // },
  {
    menuId: 4,
    path: '/data-panel',
    title: '数据中心',
    Icon: IconDataPanel,
    getlog() {
      return 'yx_center_1629184833805|44';
    },
    menus: [
      {
        menuId: 77,
        title: '我的商品',
        path: '/participant-data',
      },

      {
        menuId: 52,
        title: '活动进度监控',
        path: '/activity-progress',
        getlog() {
          return 'yx_center_1629184833805|61';
        },
      },
      {
        menuId: -1000,
        title: '综促进度监控',
        path: '/com-progress',
      },
      {
        menuId: -1000,
        title: '用户资产沉淀',
        path: '/user-asset',
        getlog() {
          return 'yx_center_1629184833805|62';
        },
      },
      {
        menuId: 67,
        title: '活动效果数据',
        path: '/activity-effect',
      },
      {
        menuId: -1000,
        title: '商品池度量',
        path: '/skupool',
      },

      {
        menuId: -1000,
        title: '分析报告',
        path: '/analysis-report',
        exact: true,
        getlog() {
          return 'yx_center_1629184833805|63';
        },
      },
      {
        menuId: -1000,
        title: '流量洞察',
        path: '/flow-insight',
        getlog() {
          return 'yx_center_1629184833805|64';
        },
      },
      {
        menuId: -1000,
        title: '实时数据',
        path: '/real-time-data',
        getlog() {
          return 'yx_center_1629184833805|65';
        },
      },
      {
        menuId: -1000,
        title: '活动概览',
        path: '/activity-summary',
        getlog() {
          return 'yx_center_1629184833805|66';
        },
      },
      {
        menuId: -1000,
        title: '活动对比',
        path: '/vs-activity',
        getlog() {
          return 'yx_center_1629184833805|67';
        },
      },
      {
        menuId: -1000,
        title: '平台数据',
        path: '/plant-data',
        getlog() {
          return 'yx_center_1629184833805|68';
        },
      },
      // {
      //   menuId: 61,
      //   title: '会场流程数据',
      //   path: '/flow-data',
      //   getLink({ parentPath }) {
      //     return parentPath + '/flow-data/activityData?hideTab=1';
      //   },
      // },
      {
        menuId: -1000,
        title: '提报运营数据',
        path: '/tibao-data',
        getlog: () => {
          return 'yx_center_1629184833805|80';
        },
      },
      {
        menuId: -1000,
        title: '频道四化看板',
        path: '/sihua',
      },
      {
        menuId: -1000,
        title: '业务经营体系',
        path: '/business-data-panel',
      },
      {
        menuId: -1000,
        title: '货盘数据看板',
        path: '/pallet-data-panel',
      },
    ],
  },
  {
    menuId: -1000, // 隐藏这个菜单
    path: '/function-matrix',
    title: '营销能力矩阵',
    Icon: IconFunctionMatrix,
  },
  {
    menuId: 46,
    path: '/trend-operation',
    title: '营销词阵地',
    Icon: IconTrend,
    getlog() {
      return 'yx_center_1629184833805|45';
    },
    menus: [
      {
        menuId: 49,
        path: '/trend-manage',
        title: '趋势管理',
        getlog() {
          return 'yx_center_1629184833805|69';
        },
        // menuId: 6,
        // exact: true,
      },
      {
        menuId: 80,
        path: '/hot-marketing',
        title: '热点营销',
      },
      {
        menuId: 81,
        path: '/trend-look',
        title: '营销词洞察',
      },
      {
        menuId: 79,
        path: '/trend-data',
        title: '趋势数据',
      },
      {
        menuId: 51,
        title: '权限管理',
        path: '/permission-manage',
        getlog() {
          return 'yx_center_1629184833805|70';
        },
      },
    ],
  },
  {
    menuId: 5,
    path: '/system',
    title: '系统设置',
    Icon: IconSystem,
    getlog() {
      return 'yx_center_1629184833805|46';
    },
    menus: [
      {
        path: '/powermanage',
        title: '权限管理',
        menuId: 6,
        exact: true,
        getlog() {
          return 'yx_center_1629184833805|71';
        },
      },
      {
        menuId: 90,
        path: '/shield-policy',
        title: '屏蔽策略配置',
        exact: true,
      },
      {
        path: '/c-shop-manager',
        title: 'C店负责人配置',
        menuId: 84,
        exact: true,
      },
      {
        path: '/channel-manage',
        title: '频道管理',
        menuId: 63,
      },
      {
        menuId: 7,
        path: '/examinemanage',
        title: '流程配置',
        exact: true,
        getlog() {
          return 'yx_center_1629184833805|72';
        },
      },
      {
        menuId: 45,
        path: '/resourcestatemanage',
        title: '资源位管理',
        exact: true,
        getlog() {
          return 'yx_center_1629184833805|73';
        },
      },
      {
        menuId: 33,
        path: '/applicationmanage',
        title: '运营位配置',
        exact: true,
        getlog() {
          return 'yx_center_1629184833805|74';
        },
      },
      {
        menuId: 62,
        path: '/whitelist',
        title: '白名单管理',
        exact: true,
      },
      {
        ignoreInRouter: true,
        menuId: 28,
        path: '/help',
        title: '帮助中心管理',
        exact: true,
        getlog() {
          return 'yx_center_1629184833805|75';
        },
        // getLink({ relativePath }) {
        //   return relativePath;
        // },
        // target: '_blank',
      },
      {
        ignoreInRouter: true,
        menuId: 31,
        path: '/admin/announce',
        title: '公告管理',
        exact: true,
        getlog() {
          return 'yx_center_1629184833805|76';
        },
        getLink({ relativePath }) {
          return relativePath;
        },
        target: '_blank',
      },
      // {
      //   menuId: 47,
      //   path: '/tree',
      //   title: '营销TREE配置',
      //   Icon: IconTree,
      //   getlog() {
      //     return 'yx_center_1629184833805|47';
      //   },
      // },
      {
        menuId: 82,
        path: '/notify',
        title: '员工端重要通知',
      },
      {
        title: '流量场类目管理',
        menuId: 85,
        path: '/flowcate',
      },
      {
        title: '排行榜运营',
        path: '/rankadmin',
      },
    ],
  },
  // {
  //   menuId: 56,
  //   title: '收品工具',
  //   path: '/ph',
  //   Icon: IconPh,
  //   hideInNav: true,
  //   getlog() {
  //     return 'yx_center_1629184833805|48';
  //   },
  //   getLink({ path }) {
  //     return `${path}/phlist/manage`;
  //   },
  // },
];
